module.exports = __webpack_public_path__ + "img/askmebet-support.c2547788.webp";